<div class="required-documentation" *ngIf="range as currentRange">
  <div class="documentation-section-header">
    <h5>{{ 'REQUIRED_DOCUMENTATION.SECTION_TITLE' | translate }}</h5>
  </div>
  <div class="documentation-card">
    <div class="documentation-header">
      <div class="documentation-header-content">
        <div class="documentation-icon-container">
          <mat-icon class="documentation-icon" svgIcon="description"></mat-icon>
        </div>
        <div class="documentation-title-section">
          <p class="documentation-title">
            {{ 'REQUIRED_DOCUMENTATION.CARD_TITLE' | translate }}
            <br aria-hidden="true" />
            <span class="documentation-subtitle">{{
              'REQUIRED_DOCUMENTATION.RANGE_SUBTITLE'
                | translate
                  : {
                      min: formatUsd(currentRange.minUsd),
                      max: formatUsd(currentRange.maxUsd)
                    }
            }}</span>
          </p>
        </div>
        <p class="documentation-instruction">
          {{ currentRange.instructions }}
        </p>
      </div>
    </div>
    <div class="documentation-items">
      <div
        class="documentation-item"
        *ngFor="let group of currentRange.groups; trackBy: trackByPersonType"
      >
        <p class="documentation-item-label">
          {{ 'REQUIRED_DOCUMENTATION.PERSON_TYPES.' + group.personType | translate }}
        </p>
        <div class="documentation-badge" *ngFor="let item of group.items">
          <mat-icon class="badge-icon" [svgIcon]="svgIconFor(item.icon)"></mat-icon>
          <span class="badge-text">{{ item.text }}</span>
        </div>
      </div>
    </div>
    <p class="documentation-note" *ngIf="currentRange.note">
      {{ currentRange.note }}
    </p>
  </div>
</div>
